import { VKVideoItem, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import { Gallery } from "src/libs/useful"
import { letterTrim } from "src/libs/utilities"
import { VIDEO_PAYER_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { NAVIGATION_DESIGN_TYPE, NAVIGATION_POSITION_TYPE, NAVIGATION_SIZE_TYPE, NAVIGATION_THEME_TYPE } from "../gallery/Gallery"
import PlayListItem from "./PlayListItem"
import { IvkVideoPlayListProps } from "./VkVideoPlayList"

/* Protopia Ecosystem component */
export interface IPlayListProps extends IvkVideoPlayListProps {
   current: VKVideoItem
   onSwitch: (i:number) => void
   containerWidth: number
   navigationPositionType?: NAVIGATION_POSITION_TYPE
   navigationSizeType?: NAVIGATION_SIZE_TYPE
   navigationThemeType?: NAVIGATION_THEME_TYPE
   navigationDesignType?: NAVIGATION_DESIGN_TYPE
}
const PlayList = (props: IPlayListProps): JSX.Element => {
    switch(props.playerDesign) {
        case VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS:
            return <CarouselIcon {...props} /> 
        case VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST:
            return <VerticalList {...props} />
        case VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST:
        default: 
            return <HorizontalList {...props} />
    }
}
export default PlayList

export const HorizontalList = (props: IPlayListProps): JSX.Element => {
    return <div className='pe-playlist-container overflow-y-auto'>
        {
            props.items.map( (item,i) => <PlayListItem 
                key={item.src} 
                item={item} 
                defImage={props.image}
                isCurrent={item.src === props.current.src} 
                i={i}
                onClick={ () => props.onSwitch(i) }
            />)
        }
    </div>
} 

export const VerticalList = (props: IPlayListProps): JSX.Element => {
    return <div className='pe-playlist-container w-100 h-auto vk-video-vertical-list'>
        {
            props.items.map( (item,i) => <PlayListItem 
                key={item.src} 
                item={item} 
                defImage={props.image}
                isCurrent={item.src === props.current.src} 
                i={i}
                onClick={ () => props.onSwitch(i) }
            />)
        }
    </div>
} 
export const CarouselIcon = (props: IPlayListProps): JSX.Element => {
    const cardWidth = props.containerWidth < WINDOW_WIDTH.TABLET
        ?
        100
        :
        props.containerWidth / 6
    const cards = props.items.map((item, i) => {
        return <div style={{ height: 160, padding: "5px 2px" }} key={item.src}>
            <div 
                className="thumbnail flex-centered text-light bg-bark"
                style={{
                    backgroundImage:`url(${item.image})`,
                    //height: 150,
                    //width: cardWidth - 4, 
                }}
                onClick={ () => { 
                    props.onSwitch(i) 
                }}
            >
                <div className="bg-dark text-light p-1">
                    { letterTrim(item.label || "", 15) }
                </div>
            </div>
        </div>
    })
    return <div className={`pe-playlist-container playlist-container${props.id}`} style={{height: 160, width: props.containerWidth}}>
        <Gallery 
            items={ cards } 
            itemWidth={ cardWidth }               
            // itemHeight={ 160 } 
            navigation
            navigationPositionType={ props.navigationPositionType }
            navigationSizeType={props.navigationSizeType}
            navigationThemeType={props.navigationThemeType}
            navigationDesignType={props.navigationDesignType}
            count={{
                [WINDOW_WIDTH.PANEL]    : 6,
                [WINDOW_WIDTH.LARGE]    : 4,
                [WINDOW_WIDTH.SCREEN]   : 4,
                [WINDOW_WIDTH.TABLET]   : 3,
                [WINDOW_WIDTH.MOBILE]   : 3,
                [WINDOW_WIDTH.SMALL]    : 1,
            }}
            loop
            type="element"
            padding={ 10 }
        />
    </div>
}


export interface IPlayListContainerProps extends IvkVideoPlayListProps {
    children: JSX.Element[]
    containerWidth: number
    current: VKVideoItem
}
export const PlayListContainer = (props: IPlayListContainerProps): JSX.Element => {
    switch(props.playerDesign) {
        case VIDEO_PAYER_DESIGN_TYPE.CAROUSEL:
            return <>
                <div 
                    className={`pe-vk-video-play-list-carousel-icon-container pe-vk-video-play-list-carousel flex-column playlist-container${props.id}`} 
                    style={{ 
                        width: props.containerWidth, 
                    }}
                >
                    {props.children}
                </div> 
                <div className="vk-playlist-description-content small mt-1">
                    <div className="title">{props.current?.label}</div>
                    {props.current?.content} 
                </div>
            </>
        case VIDEO_PAYER_DESIGN_TYPE.CAROUSEL_ICONS:
            return <>
                <div 
                    className={`pe-vk-video-play-list-carousel-icon-container flex-column playlist-container${props.id}`} 
                    style={{ 
                        width: props.containerWidth, 
                    }}
                >
                    {props.children}
                </div> 
                <div className="vk-playlist-description-content small mt-1">
                    <div className="title">{props.current?.label}</div>
                    {props.current?.content} 
                </div>
            </>
        case VIDEO_PAYER_DESIGN_TYPE.VERTICAL_LIST:
            return <>
                <div 
                    className={`pe-vk-video-play-list-container flex-column playlist-container${props.id}`} 
                    style={{
                        width: props.containerWidth
                    }}
                >
                    {props.children}
                </div> 
                <div className="vk-playlist-description-content small mt-1">
                    <div className="title">{props.current?.label}</div>
                    {props.current?.content} 
                </div>
            </>
        case VIDEO_PAYER_DESIGN_TYPE.HORIZONTAL_LIST:
        default: 
            return <>
                <div 
                    className={`pe-vk-video-play-list-container `} 
                    style={{
                        height: props.btnHeight // || 400 
                    }}
                >
                    {props.children}
                </div> 
                <div className="vk-playlist-description-content small mt-1">
                    <div className="title">{props.current?.label}</div>
                    {props.current?.content} 
                </div>
            </>
    } 
}